import { ReactElement } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { getToken } from './api';

const ProtectedRoute = ({ children }: { children: ReactElement }) => {
  const location = useLocation();
  if (!getToken()) {
    return <Navigate to="/admin/login" replace state={{ from: location.pathname }} />;
  }
  return children;
};

export default ProtectedRoute;
